import { CircularProgress } from '@mui/material';
import { PropsWithChildren } from 'react';

const LoadingWrapper = ({
    loading,
    className,
    ...props
}: PropsWithChildren<{ className?: string; loading: boolean }>) => {
    return loading ? <CircularProgress className={className} /> : props.children;
};

export { LoadingWrapper };
